module.exports = __webpack_public_path__ + "img/sub.ee2e3737.svg";